module.exports = __webpack_public_path__ + "static/media/user-circle.47078676.svg";